import {Base} from "@/api/Base"

export class ServiceProviderAdd extends Base {
    path = "serviceProvider/add"
}